import { render, staticRenderFns } from "./FieldExtraInfo.vue?vue&type=template&id=279b4656&"
import script from "./FieldExtraInfo.vue?vue&type=script&lang=ts&"
export * from "./FieldExtraInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FieldExtraInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports